module.exports = __webpack_public_path__ + "5.0.2/img/logo_3.62296414.png";